import {
  Component,
  ElementRef,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { LayoutService } from '../services/layout.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-sidebar',
  templateUrl: './notification-sidebar.component.html',
  styleUrls: ['./notification-sidebar.component.scss'],
})
export class NotificationSidebarComponent implements OnDestroy {
  layoutSub: Subscription;
  isOpen = false;

  @ViewChild('sidebar', { static: false }) sidebar: ElementRef;

  constructor(
    private _renderer: Renderer2,
    private _layoutService: LayoutService,
  ) {
    this.layoutSub = this._layoutService.notiSidebarChangeEmitted$.subscribe(
      (): void => {
        if (this.isOpen) {
          this._renderer.removeClass(this.sidebar.nativeElement, 'open');
          this.isOpen = false;
        } else {
          this._renderer.addClass(this.sidebar.nativeElement, 'open');
          this.isOpen = true;
        }
      },
    );
  }

  ngOnDestroy(): void {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  onClose(): void {
    this._renderer.removeClass(this.sidebar.nativeElement, 'open');
    this.isOpen = false;
  }
}
